import { combineReducers } from 'redux';
import { FILTER_ASSETS } from 'signoxe/constants/actionTypes';

const assetType = (state = null, action) => {
  if (action.type === FILTER_ASSETS && action.filterBy === 'TYPE') {
    if (action.filter === state) return null;
    else return action.filter;
  } else return state;
};

const assetAspect = (state = null, action) => {
  if (action.type === FILTER_ASSETS && action.filterBy === 'ASPECT') {
    if (action.filter === state) return null;
    else return action.filter;
  } else return state;
};

const assets = combineReducers({
  aspect: assetAspect,
  type: assetType,
});

const filterState = combineReducers({
  assets,
});

export default filterState;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/filterState.js